import React from "react";

import { useRequestPairingCode } from "@/shared/api/interfaces";
import { FieldLabel, PrimaryButton, TextInput } from "@/shared/components/settings-atoms";
import { FormError } from "./FormError";
import { Steps } from "./Steps";

const TYPE_IT = [
  "On the phone: Settings → Linked devices → Link a device.",
  "Tap “Link with phone number instead”.",
  "Type this code.",
];

/* Linking by typing a code on the phone instead of scanning one — for when the
   phone's camera is not an option. The number is not a secret: it only tells
   WhatsApp which account the code is for. The link is still polled meanwhile,
   so the dialog moves on by itself once the code is typed. */
export function PairingCode({ interfaceId }: { interfaceId: string }) {
  const pairing = useRequestPairingCode();
  const code = pairing.data?.code;

  if (code) {
    return (
      <>
        <div className="rounded-[12px] bg-[var(--surface-sunk)] ring-1 ring-[var(--hairline)] py-4 text-center font-mono text-[22px] tabular-nums tracking-[0.08em] text-[var(--text-primary)]">
          {code}
        </div>
        <Steps items={TYPE_IT} />
      </>
    );
  }

  return (
    <form
      className="space-y-3"
      onSubmit={(e) => {
        e.preventDefault();
        const phone = e.currentTarget.elements.namedItem("phone") as HTMLInputElement;
        pairing.mutate({ id: interfaceId, phone: phone.value });
      }}
    >
      <div>
        <FieldLabel>Phone number, with its country code</FieldLabel>
        <TextInput
          name="phone"
          aria-label="Phone number"
          type="tel"
          autoComplete="off"
          placeholder="+91 98765 43210"
          onChange={() => {
            if (pairing.error) pairing.reset();
          }}
        />
      </div>
      <FormError error={pairing.error} />
      <PrimaryButton type="submit" disabled={pairing.isPending}>
        {pairing.isPending ? "Getting a code…" : "Get a code"}
      </PrimaryButton>
    </form>
  );
}
